
import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LoaderService } from '@shared/services/loader/loader.service';

@Component({
    selector: 'avenir-loader',
    imports: [],
    templateUrl: './loader.component.html',
    styleUrl: './loader.component.scss'
})
export class LoaderComponent {
  @Input() showText = true;
  isLoading = false;
  constructor(
    protected loaderService: LoaderService,
    private cdr: ChangeDetectorRef
  ) {
  }

  ngOnInit(): void {
    this.loaderService.isLoading$.subscribe(isLoading => {
      this.isLoading = isLoading;
      this.cdr.detectChanges();
    })
  }
}